import React from 'react'

import { LineageOptions, ProductTypeOptions, Options } from '../../types'

interface SelectionOptionsProps {
  options: Options[]
}

interface IdSelectionOptionsProps {
  options: (LineageOptions | ProductTypeOptions)[]
}

export const IdSelectionOptions = ({ options }: IdSelectionOptionsProps) => (
  <>
    {options.map((option) => (
      <option value={typeof option?.id === 'number' ? option?.id : option.value} key={option.key}>
        {option.text}
      </option>
    ))}
  </>
)

export const SelectionOptions = ({ options }: SelectionOptionsProps) => (
  <>
    {options.map((option) => (
      <option value={option.value} key={option.key}>
        {option.text}
      </option>
    ))}
  </>
)
